import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchCompany = (companyId) => api.get(`/company/${companyId}`).then((res) => res.data);

export default function useCompany(companyId) {
  return useQuery(['companies', companyId], () => fetchCompany(companyId));
}